import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Input, Select, message } from "antd";
import { zoneAPI } from "../../api/RateCardApi";
import "./style.scss";

const AddZoneModal = ({
  isModalOpen,
  setIsModalOpen = () => {},
  editSelectedZone,
  setEditSelectedZone,
  getAllZoneList = () => {},
  action = null,
  rateCardId = null,
  // customerId = null,
  // rateCardType = null,
}) => {
  const [form] = Form.useForm();
  const [allPinOptions, setAllPinOptions] = useState([]);
  const [allPincodes, setAllPincodes] = useState([]);

  useEffect(() => {
    const pincodes = JSON?.parse(localStorage?.getItem("allPincodes"));
    setAllPinOptions(
      pincodes?.map((item) => ({
        label: item?.Pincode?.toString(),
        value: item?.Pincode?.toString(),
      }))
    );
    setAllPincodes(
      pincodes?.map((item) => ({
        label: item?.Pincode?.toString(),
        value: item?.Pincode?.toString(),
      }))
    );
  }, []);

  useEffect(() => {
    if (editSelectedZone?.name) {
      //   let item = [];
      //   for (let i = 0; i < 100; i++) {
      //     item.push({
      //       label: editSelectedZone?.pincodes[0],
      //       value: editSelectedZone?.pincodes[0],
      //     });
      //   }
      form.setFieldsValue({
        name: editSelectedZone?.name,
        pincodes: editSelectedZone?.pincodes,
        // pincodes: item,
      });
    }
  }, [editSelectedZone]);

  const addNewZone = async (values) => {
    const headers = {
      //parent: JSON.parse(localStorage.getItem("userinfo"))?.roles?.[0],
      parent: localStorage.getItem("userinfo")?.roles?.includes("CP")
        ? "CP"
        : "HO",
    };
    let payload = {};
    let rateCard = rateCardId || undefined;
    if (action === "assign_customer") {
      payload = {
        name: values.name,
        pincodes: values.pincodes?.map((item) => parseInt(item)),
        rateCardId: rateCard,
        // userId: customerId?.toString(),
        //rateCategory: rateCardType,
      };
    } else {
      payload = {
        name: values.name,
        pincodes: values.pincodes?.map((item) => parseInt(item)),
        rateCardId: rateCardId,
      };
    }
    let response;
    if (editSelectedZone?.name) {
      response = await zoneAPI.patchZone(
        editSelectedZone?.id,
        payload,
        headers
      );
    } else {
      response = await zoneAPI.createZone(payload, headers);
    }
    if (response.status) {
      getAllZoneList();
      setIsModalOpen(false, values);
      form.resetFields();
      setEditSelectedZone(null);
      message.success("Zone created successfully");
    } else {
      message.error(
        response?.response?.data?.message || "Zone creation failed"
      );
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");

    // Get current values from form/state
    const currentValues = form.getFieldValue("pincodes") || [];

    // Track statistics for user feedback
    // let stats = {
    //   added: 0,
    //   duplicatesRemoved: 0,
    //   invalid: 0,
    // };

    // Handle comma-separated values
    if (pastedText.includes(",")) {
      // Process all values including current and new
      const allValues = [
        ...currentValues,
        ...pastedText
          .split(",")
          .map((value) => value.trim())
          .filter((value) => {
            // Check for valid format (6 digits)
            if (!value || !/^\d{6}$/.test(value)) {
              //stats.invalid++;
              return false;
            }
            return true;
          }),
      ];

      // Remove duplicates using Set
      const uniqueValues = [...new Set(allValues)];

      // Calculate stats
      // stats.duplicatesRemoved = allValues.length - uniqueValues.length;
      // stats.added = uniqueValues.length - currentValues.length;

      // Update form with unique values
      form.setFieldValue("pincodes", uniqueValues);
    } else {
      // Handle single value paste
      const value = pastedText.trim();

      if (!value || !/^\d{6}$/.test(value)) {
        message.error("Invalid pincode format. Please enter 6 digits.");
        return;
      }

      // Add new value and remove duplicates
      const allValues = [...currentValues, value];
      const uniqueValues = [...new Set(allValues)];

      if (uniqueValues.length === currentValues.length) {
        message.warning("This pincode already exists");
        return;
      }

      form.setFieldValue("pincodes", uniqueValues);
      message.success("New pincode added");
    }
  };

  const handlePincodeSearch = (value) => {
    // if (debounceTimeout.current) {
    //   clearTimeout(debounceTimeout.current);
    // }

    // debounceTimeout.current = setTimeout(async () => {
    if (value?.length > 0) {
      const filtered = allPincodes
        ?.filter((item) => {
          const pincode = String(item?.value);
          const searchValue = String(value);

          if (searchValue?.length === 6) {
            return pincode === searchValue;
          }

          return pincode?.startsWith(searchValue);
        })
        .map((item) => ({
          value: item?.value,
          label: `${item?.label}`,
        }));

      if (filtered?.length > 0) {
        setAllPinOptions(filtered);
      } else {
        setAllPinOptions(allPincodes);
      }
    } else {
      setAllPinOptions(allPincodes);
    }
  };

  return (
    <>
      <Modal
        title={editSelectedZone?.name ? "Edit Zone " : "Add New Zone"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          form.resetFields();
          setEditSelectedZone(null);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setIsModalOpen(false);
              form.resetFields();
              setEditSelectedZone(null);
            }}
          >
            Cancel
          </Button>,
          <Button key={"submit"} onClick={() => form.submit()} type="primary">
            {editSelectedZone?.name ? "Update" : "Add"}
          </Button>,
        ]}
        width={1000}
      >
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          onFinish={addNewZone}
          className="add-zone-form"
        >
          <Row gutter={20} className="global-form-row">
            <Col span={12}>
              <Form.Item
                name="name"
                label="Zone Name"
                rules={[{ required: true, message: "Fill zone name" }]}
              >
                <Input placeholder="Enter Zone Name" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item
                name="pincodes"
                label="Pincodes"
                rules={[
                  {
                    required: true,
                    message: "Fill pincodes",
                  },
                  {
                    validator: (_, value) => {
                      if (!value || value.length === 0) {
                        return Promise.resolve(); // Allow empty
                      }
                      const pinRegex = /^[1-9][0-9]{5}$/; // Example: Indian pincode: 6 digits, first not 0
                      const invalidPins = value.filter(
                        (pin) => !pinRegex.test(pin)
                      );
                      if (invalidPins.length > 0) {
                        return Promise.reject(
                          new Error(
                            `Invalid pincode: ${invalidPins.join(", ")}`
                          )
                        );
                      }
                      console.log(form.getFieldValue("pincodes"), "hit", value);
                      return Promise.resolve();
                    },
                  },
                ]}
                onKeyPress={(e) => {
                  if (/[^0-9,]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              >
                <Select
                  onPaste={handlePaste}
                  options={allPinOptions}
                  className="pincode-tag"
                  size="small"
                  mode="tags"
                  placeholder="Pincodes"
                  showSearch
                  onSearch={(value) => {
                    handlePincodeSearch(value);
                  }}

                  // filterOption={(input, option) =>
                  //   (option?.label ?? "")
                  //     .toLowerCase()
                  //     .includes(input.toLowerCase())
                  // }
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddZoneModal;
